import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useSupportedDevicesData } from "../../../hooks/use_site";

export default function MeterTypeSelect({ value, onChange, disabled = false }) {
  value = value !== null ? value : "";
  const { data: supportedDevices } = useSupportedDevicesData();

  return (
    <FormControl fullWidth>
      <InputLabel>Meter type</InputLabel>
      <Select
        value={value}
        label="Meter type"
        disabled={disabled}
        onChange={(event) => {
          onChange(event);
        }}
      >
        {(supportedDevices?.meter || []).map((device) => {
          if (device?.is_visible !== 1 || (device?.dev_only && process.env.REACT_APP_ENV === "PROD")) return null;
          return (
            <MenuItem key={device?.device_type} value={device?.device_type}>
              {device?.device_alias}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
